function updateFullNodeName() {
    var _a;
    this._fullNodeName = [(_a = this.parent) === null || _a === void 0 ? void 0 : _a._fullNodeName, this.nodeName]
        .filter(function notEmptyNames(name) {
        return name;
    })
        .join('.');
}
function NamedNode(nodeName) {
    const name = nodeName ? String(nodeName) : '';
    Object.defineProperty(this, 'nodeName', {
        value: name,
        enumerable: true,
    });
    this._fullNodeName = name;
    // If we have a parent, the parent plugin is available and we're not the root
    if (this.parent) {
        this.signals.onAncestryChanged.add(updateFullNodeName, this);
        updateFullNodeName.call(this);
    }
}
Object.defineProperties(NamedNode.prototype, {
    fullNodeName: {
        get: function fullNodeName() {
            if (this._checkAncestry)
                this._checkAncestry();
            return this._fullNodeName;
        },
        enumerable: true,
        configurable: true,
    },
});
export default {
    pluginName: 'nodeName',
    dependencies: ['parent'],
    nodeInit: NamedNode,
    nodeMethods: NamedNode.prototype,
};
//# sourceMappingURL=node-name.js.map